import { Box } from '@factorialco/deprecated-design-system'

export const SidebarSection = ({ children }: React.PropsWithChildren) => {
  return (
    <Box
      gap="s12"
      width="full"
      padding="s24"
      justifyContent="center"
      alignItems="center"
      border={{
        all: {
          width: 's1',
          style: 'solid',
          color: 'grey400',
        },
      }}
      borderRadius={{ all: 'abs008' }}
    >
      {children}
    </Box>
  )
}
